import React, { useState, useCallback } from "react";
import { Tabs, Form, Button, message as antdMessage, Tag } from "antd";
import { getCustomPromptResponse } from "../../apis/MarketingSmsAPI";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import "./marketing.scss";
import useMarketingStore from "../../store/useMarketingStore";

const MessageTab = ({ apiData, loading, onSubmit, updateShowMessages, marketingPage, objectId, handleCTAResponse }) => {
    const [instruction, setInstruction] = useState('');
    const [generatedMessages, setGeneratedMessages] = useState({});
    const [currentTab, setCurrentTab] = useState('1');
    const [customeLoading, setCustomeLoading] = useState(false);
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { ctaResponseReceived } = useMarketingStore();



    //  Correct destructuring from nested response    
    const { answer = [], reason = [], tags = [] } =  marketingPage.marketingTabIndex === 3 ? { answer: apiData ?.data ?.response } : (apiData ?.data ?.response || {});
    const formatText = (text) => {
        if (!text) return "";
        let htmlText = String(text).replace(/\n/g, '<br>');
        htmlText = htmlText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        htmlText = htmlText.replace(/\*(.*?)\*/g, '<em>$1</em>');
        return htmlText;
    };

    const handleTabChange = (key) => {
        setInstruction('');
        setCurrentTab(key);
    };

    const generateNew = () => {
        if (ctaResponseReceived) {
            handleCTAResponse();
            setGeneratedMessages({});
        } else {
            onSubmit();
            setInstruction("");
            setGeneratedMessages({});
            setCurrentTab("1");
        }
    };

    const handleInstructionChange = (value) => {
        const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
        if (htmlTagRegex.test(value)) {
            antdMessage.destroy();
            antdMessage.error("Invalid input");
            return;
        }
        setInstruction(value);
    };

    const generateMessages = useCallback(async (message, currentTab, instruction, objectId) => {
        try {
            const values = await form.validateFields();
            if (values) {
                setCustomeLoading(true);
                let payload = {
                    prompt: message,
                    type: ctaResponseReceived
                        ? "cta"
                        : (marketingPage.marketingTabIndex === 0
                            ? "sms"
                            : marketingPage.marketingTabIndex === 1
                                ? "subject"
                                : "email"),
                    instruction: instruction,
                    objectId: objectId,
                    index: currentTab
                };
                const response = await dispatch(getCustomPromptResponse(payload));
                if (response.error) {
                } else {
                    const customgeneratedContent = response.payload.data;
                    setGeneratedMessages((prevState) => ({
                        ...prevState,
                        [currentTab]: [`"${formatText(customgeneratedContent[0])}"`],
                    }));
                }
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setCustomeLoading(false);
        }
    }, [ctaResponseReceived]);

    const handelBack = () => {
        updateShowMessages();
        setGeneratedMessages({});
    };

    const messageItemStyle = {
        backgroundColor: '#efeeee',
        padding: '12px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        margin: '10px 0',
        borderColor: "black"
    };

    return (
        <div>
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <a onClick={handelBack} style={{ fontSize: '14px', color: '#1890ff', display: 'flex', alignItems: 'center' }}>
                    <ArrowLeftOutlined style={{ marginRight: '8px' }} /> Back
                </a>
                <button className="btn-outlined">
                    <div className="btn-outlined-content">
                        <div onClick={generateNew} className="text">Generate New</div>
                    </div>
                </button>
            </div>

            {/* Messages */}
            <div style={{
                backgroundColor: 'white',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                maxHeight: "70vh",
                overflowY: 'auto'
            }}>
                <Tabs className="tabs-head" activeKey={currentTab} onChange={handleTabChange}>
                    {Array.isArray(answer) && answer.length > 0 ? (
                        answer.map((msg, index) => (
                            <Tabs.TabPane tab={`${marketingPage ?.marketingPage} ${index + 1}`} key={(index + 1).toString()} sticky>
                                <div>
                                    <p dangerouslySetInnerHTML={{ __html: formatText(msg) }} />
                                    <p style={{ fontSize: "11px", marginTop: "-0.5rem", color: "grey" }}>
                                        This content was created using Generative AI technology. Please review and verify before sharing with customers.
                                    </p>

                                    {/* Reasons */}
                                    {Array.isArray(reason) && reason.length > 0 && (
                                        <div style={{ marginTop: "20px" }}>
                                            <h4>Reasons</h4>
                                            <ul>
                                                {reason.map((r, i) => (
                                                    <li key={i}>{r}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {/* Tags */}
                                    {Array.isArray(tags) && tags.length > 0 && (
                                        <div style={{ marginTop: "20px" }}>
                                            {/* <h4>Tags</h4> */}
                                            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                                {tags.map((tag, i) => (
                                                    <Tag key={i} color="blue" style={{ borderRadius: "16px", padding: "4px 10px" }}>
                                                        {tag}
                                                    </Tag>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Custom prompt textarea */}
                                    <textarea
                                        style={{
                                            width: '100%',
                                            height: '60px',
                                            marginTop: '10px',
                                            padding: '10px',
                                            fontSize: '12px',
                                            borderRadius: '6px',
                                            border: '1px solid #ddd',
                                            resize: 'none',
                                        }}
                                        onChange={(e) => handleInstructionChange(e.target.value)}
                                        value={instruction}
                                        placeholder="Enter your instructions here to further customize the above content"
                                    />

                                    <Button
                                        type="primary customPrompt-button"
                                        onClick={() => generateMessages(msg, currentTab, instruction, objectId)}
                                        loading={customeLoading}
                                        style={{ marginTop: "10px" }}
                                    >
                                        Custom Prompt
                                    </Button>

                                    {generatedMessages[currentTab] && (
                                        <div className="message-container" style={{ marginTop: '20px' }}>
                                            {generatedMessages[currentTab].map((generatedMessage, idx) => (
                                                <div className="message-item" key={idx} style={messageItemStyle}>
                                                    <p dangerouslySetInnerHTML={{ __html: String(generatedMessage).replace(/^"|"$/g, '') }} />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Tabs.TabPane>
                        ))
                    ) : (
                            <Tabs.TabPane tab="Message" key="1"><p>No data available</p></Tabs.TabPane>
                        )}
                </Tabs>
            </div>
        </div>
    );
};

export default MessageTab;
